import React from 'react';
import { Play } from 'lucide-react';
import { useInView } from 'react-intersection-observer';
import Section from '../Section';

const Projects: React.FC = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <Section
      id="demo"
      className="bg-[#F5F3EF]"
      rootMargin="100px"
    >
      {/* フルワイド画像 */}
      <div className="relative h-[180px] sm:h-[260px] lg:h-[340px] overflow-hidden">
        <img
          src="/images/demo.webp"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#F5F3EF]" />
      </div>

      <div ref={ref} className={`mx-auto max-w-6xl px-5 lg:px-6 pb-20 pt-8 lg:pb-28 lg:pt-12 transition-all duration-1000 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 rounded-full border border-[#B8860B]/30 bg-[#B8860B]/10 px-4 py-1.5 mb-6">
            <Play className="h-4 w-4 text-[#B8860B]" />
            <span className="text-sm font-semibold text-[#B8860B]">開発の様子</span>
          </div>
          <h2 className="text-3xl font-bold lg:text-4xl leading-tight text-[#2D3748]">
            AIなら、1人でも<br />
            <span className="text-gradient">複数人分の開発ができる</span>
          </h2>
          <p className="text-[#5A6577] mt-4 max-w-xl mx-auto text-justify">
            従来は複数のエンジニアが何ヶ月もかけていた開発を、AIを活用して1人でスピーディに実現。その過程を動画でご覧ください。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* YouTube動画 */}
          <div className="rounded-2xl border border-[#E8E6E1] bg-white overflow-hidden shadow-sm">
            <div className="aspect-video bg-black">
              <iframe
                src="https://www.youtube.com/embed/62nUb8YAx7k"
                title="Claude CodeでWebアプリを作る様子"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
                className="w-full h-full"
              />
            </div>
            <div className="p-5">
              <h3 className="text-lg font-bold text-[#2D3748]">Claude CodeでWebアプリを作る様子</h3>
              <p className="text-[#5A6577] text-sm mt-1">AIを使った実際の開発風景をノーカットでお見せします</p>
            </div>
          </div>

          {/* RODO プレースホルダー */}
          <div className="rounded-2xl border border-[#E8E6E1] bg-white overflow-hidden shadow-sm">
            <div className="aspect-video bg-gradient-to-br from-[#EDEBE6] to-[#F5F3EF] flex items-center justify-center">
              <div className="text-center p-6">
                <div className="inline-flex items-center gap-1.5 rounded-full border border-[#B8860B]/30 bg-[#B8860B]/10 px-3 py-1 text-xs font-bold text-[#B8860B] mb-3">
                  準備中
                </div>
                <p className="text-[#7B8794] text-sm">実際のクライアント案件の<br />開発過程を公開予定</p>
              </div>
            </div>
            <div className="p-5">
              <h3 className="text-lg font-bold text-[#2D3748]">業務管理システム開発</h3>
              <p className="text-[#5A6577] text-sm mt-1">Coming soon — 実案件の開発過程ダイジェスト</p>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Projects;
